import { get, post } from "../../config/api";
import { SERVER_URL } from "../../config/app.config";

class InventoryPlanService {
	static async getInventoryPlan(planId) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/plan/${planId}`;
		return await get({ url });
	}

	static async getInventoryPlans(restaurantId) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/list/${restaurantId}`;
		return await get({ url });
	}

	static async createInventoryPlan(data) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/create`;
		return await post({ url, data });
	}

	static async getInventoryDetails(data) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/inventoryDetails`;
		return await post({ url, data });
	}

	static async updateInventoryPlan(planId, data) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/update/${planId}`;
		return await post({ url, data });
	}

	static async getCurrentInventory(restaurantId) {
		const url = SERVER_URL + `/v1/admin/inventoryPlan/inventory?restaurantId=${restaurantId}`;
		return await get({ url });
	}

	static async getCurrentInventoryGraph(restaurantId) {
		const url = SERVER_URL + `/v1/admin/inventory/${restaurantId}/graph`;
		return await get({ url });
	}

}

export default InventoryPlanService;
